import React from "react";

import { Box } from "@chakra-ui/react";
import { Dialog } from "../../../components/Dialog";
import { HOSTNAME } from "../../../utils/request";
import { P } from "../../../components/Type";

const QrCodeOverlay = ({
  username,
  barcodeColor = "#333",
  topLabel = "",
  bottomLabel = "",
  noBorder,
  bodyFont,
  backgroundColor,
}) => {
  const Wrapper = noBorder ? Box : Dialog;
  const qrCodeDOM = React.useRef();
  const qrCode = React.useRef();

  React.useLayoutEffect(() => {
    const QRCode = require("easyqrcodejs");
    const options = {
      text: `${HOSTNAME}/${username}`,
      correctLevel: QRCode.CorrectLevel.M,
      width: 300,
      height: 300,

      colorDark: barcodeColor,
      colorLight: "transparent",
      dotScale: 0.85,
      // LOGO
      logo: `${HOSTNAME}/qr.png`,
      logoBackgroundTransparent: true,
      logoWidth: 130,
      logoHeight: 130,
    };
    // Create new QRCode Object
    if (qrCode.current) {
      qrCode.current.clear();
    }

    try {
      qrCode.current = new QRCode(qrCodeDOM.current, options);
    } catch (error) {
      console.log(error);
    }
  }, [username, barcodeColor]);

  return (
    <Box marginBottom={4}>
      <Wrapper
        display="flex"
        width={300}
        flexDirection="column"
        backgroundColor={backgroundColor}
      >
        {topLabel.length ? (
          <P
            w="100%"
            wordWrap="break-word"
            textAlign="center"
            fontFamily={bodyFont}
          >
            {topLabel}
          </P>
        ) : null}
        <Box w={"100%"} ref={qrCodeDOM}></Box>
        {bottomLabel.length ? (
          <P
            textAlign="center"
            w="100%"
            wordWrap="break-word"
            marginBottom={0}
            marginTop={3}
            fontFamily={bodyFont}
          >
            {bottomLabel}
          </P>
        ) : null}
      </Wrapper>
    </Box>
  );
};

export { QrCodeOverlay };
